/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react';
import {ScorecardTable} from '../styles';
import {Utils} from '../../../../utils/api';
import {GoChevronDown, GoChevronUp} from 'react-icons/go';
import {SelectPlayerColumn} from '../../../../components';
import {ColumnContainerSummary, ArrowHolderSummary} from '../../../../components/Table/styles';
import {default as TableContainer} from '../tableContainer';

export default ({dataTableContent}: {dataTableContent: Array<any>}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);
  const [sort, useSort] = useState<string>('');
  const [reverse, useReverse] = useState<boolean>(false);
  const sortOptions = [!reverse, changeTable, table];
  const UTILS = new Utils();
  useEffect(() => {
    const newExams = dataTableContent?.filter(item => {
      if (item?.trainingAccountability?.lastTrainingDay) {
        return item;
      } else {
        return false;
      }
    });
    useTable(newExams);
  }, [dataTableContent]);
  function changeTable(e) {
    useTable([...e]);
  }

  function toggleSortString(sort, params) {
    useSort(sort);
    useReverse(!reverse);
    UTILS.SortStrings(params, sortOptions);
  }

  const SortingTableHead = ({
    title,
    attr,
    location,
    sortFunction,
  }: {
    title?: string;
    attr?: any;
    location?: any;
    sortFunction: Function;
  }) => {
    return (
      <th onClick={() => sortFunction(attr, location)}>
        <ColumnContainerSummary>
          <span>{title}</span>
          <ArrowHolderSummary>
            {sort === attr && reverse && <GoChevronDown size={14} />}
            {sort === attr && !reverse && <GoChevronUp size={14} />}
          </ArrowHolderSummary>
        </ColumnContainerSummary>
      </th>
    );
  };

  return (
    <TableContainer title={'Training Accountability'} numberOfPlayers={table.length} subTitle="Training Alerts equal or less than 7 days">
      <ScorecardTable>
        <thead>
          <tr>
            <SortingTableHead title="Players" attr="firstName" location={['player', 'firstName']} sortFunction={toggleSortString} />
            <SortingTableHead
              title="Last Training Day"
              attr="ltd"
              location={['trainingAccountability', 'lastTrainingDay']}
              sortFunction={toggleSortString}
            />
            <SortingTableHead
              title="Last 7 Days"
              attr="last7days"
              location={['trainingAccountability', 'last7Days']}
              sortFunction={toggleSortString}
            />
          </tr>
        </thead>
        <tbody>
          {table?.length > 0 ? (
            table?.map((item, index) => {
              return (
                <tr key={index}>
                  <SelectPlayerColumn player={item?.player} />
                  <td>
                    {(item?.trainingAccountability?.lastTrainingDay !== undefined ||item?.trainingAccountability?.lastTrainingDay !== null)
                      ? item?.trainingAccountability?.lastTrainingDay
                      : '-'}
                  </td>
                  <td>
                    {(item?.trainingAccountability?.last7Days !== undefined ||item?.trainingAccountability?.last7Days !== null) ? item?.trainingAccountability?.last7Days : '-'}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>No Data</td>
            </tr>
          )}
        </tbody>
      </ScorecardTable>
    </TableContainer>
  );
};
